import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent} from './components/home/home.component'
import { AboutComponent} from './components/about/about.component'
import { ServicesComponent} from './components/services/services.component'
import { ContactComponent} from './components/contact/contact.component'

const routes: Routes = [
  { path: 'home', component:  HomeComponent},
  { path: 'about', component:  AboutComponent},
  { path: 'services', component:  ServicesComponent},
  { path: 'contact', component:  ContactComponent},
  { path: '**', pathMatch: 'full', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
